import React, { useEffect } from 'react';
import { getBrandedLoginRouteFromSearch } from './cidLoginRouting';
import { isSafePostLoginRoute } from '../../auth/pcAuthBrowserFlow';

const LoginRedirect = (props) => {

  useEffect(() => {
    // Capture the protected URL the user was trying to reach BEFORE navigating to
    // login. This is the single redirect choke point for all route guards. It must
    // happen here because the guards' own effects run after this component has
    // already changed window.location to the login route.
    const intendedRoute = window.location.pathname + window.location.search;
    if (isSafePostLoginRoute(intendedRoute)) {
      localStorage.setItem('intendedRoute', intendedRoute);
    }

    const brandedRoute = getBrandedLoginRouteFromSearch(window.location.search);
    if (brandedRoute) {
      props.history.replace(brandedRoute);
      return;
    }

    props.history.replace('/Login');
  }, [props.history]);

  return null;
};

export default LoginRedirect;
